import coachingSession from "./coachingSession.json";
import common from "./common.json";
import mobileRequired from "./mobileRequired.json";
import needHelp from "./needHelp.json";
import resetPassword from "./resetPassword.json";
import sessionSurvey from "./sessionSurvey.json";

export default {
  translation: {
    ...common,
    ...coachingSession,
    ...mobileRequired,
    ...needHelp,
    ...resetPassword,
    ...sessionSurvey,
  },
};
